export const THEME_MODE_STORAGE_KEY = "mui-mode"
export const THEME_COLOR_SCHEME_STORAGE_KEY = "mui-color-scheme"
export const DEFAULT_THEME_MODE = "light"

/** Default when no preference is stored; must be a key in PREFERENCE_TO_MUI_SCHEME. */
export const DEFAULT_THEME_PREFERENCE = "system"

export const THEME_PREFERENCE_KEY = "themeMode"
export const THEME_PREFERENCE_TYPE = "ui"

export const APP_COLOR_SCHEME_ATTRIBUTE = "data-mui-color-scheme"

export const PREFERENCE_TO_MUI_SCHEME = {
  "light-colors": "light",
  "dark-colors": "dark",
  system: "system",
}

export const VALID_THEME_PREFERENCES = Object.keys(PREFERENCE_TO_MUI_SCHEME)

// Call at module load: this app has no hydration step, so a rendered <script> would commit too late to win the race with ThemeProvider's init.
export function seedMuiColorSchemeStorage() {
  try {
    const preference = localStorage.getItem(THEME_PREFERENCE_KEY) || DEFAULT_THEME_PREFERENCE
    const muiMode = PREFERENCE_TO_MUI_SCHEME[preference]
    if (!muiMode) {
      return
    }
    if (localStorage.getItem(THEME_MODE_STORAGE_KEY) !== muiMode) {
      localStorage.setItem(THEME_MODE_STORAGE_KEY, muiMode)
    }
    if (muiMode === "light" || muiMode === "system") {
      if (localStorage.getItem(`${THEME_COLOR_SCHEME_STORAGE_KEY}-light`) !== "light") {
        localStorage.setItem(`${THEME_COLOR_SCHEME_STORAGE_KEY}-light`, "light")
      }
    }
    if (muiMode === "dark" || muiMode === "system") {
      if (localStorage.getItem(`${THEME_COLOR_SCHEME_STORAGE_KEY}-dark`) !== "dark") {
        localStorage.setItem(`${THEME_COLOR_SCHEME_STORAGE_KEY}-dark`, "dark")
      }
    }
  } catch {
    // localStorage unavailable; ThemeProvider falls back to its own default.
  }
}

export function applyMuiSchemeFromPreference(preference, { setMode, setColorScheme }) {
  const muiScheme = PREFERENCE_TO_MUI_SCHEME[preference]
  if (muiScheme !== "light" && muiScheme !== "dark" && muiScheme !== "system") {
    return
  }
  setMode(muiScheme)
  if (!setColorScheme) {
    return
  }
  if (muiScheme === "light") {
    setColorScheme({ light: "light" })
  } else if (muiScheme === "dark") {
    setColorScheme({ dark: "dark" })
  } else {
    setColorScheme({ light: "light", dark: "dark" })
  }
}
